export default {
  root: {
    textTransform: 'uppercase',
    fontWeight: 600,
  },
}
